import { MAX_LABEL_LENGTH } from './constants'

export const truncateText = (text: string, maxLength: number = MAX_LABEL_LENGTH): string => {
  return text && text.length > maxLength ? `${text.substring(0, maxLength)}...` : text
}
